import type { ILogService } from "angular";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IWidgetComponentController } from "../IWidgetComponentController";

export class SitesWidgetComponentController implements IWidgetComponentController {
    public static $inject = ["$log", "sitesRepository"];

    public icon: string;

    public caption: string;

    public subCaption: string = null;

    public url: string;

    public isLoading: boolean;

    constructor(private $log: ILogService, private sitesRepository: ISitesRepository) {
        this.icon = "building";

        this.url = "#/sites";

        this.caption = "Soon subscribing to observable...";
        this.isLoading = true;
        setTimeout(() => {
            this.caption = "All of my favorite sites";
            this.sitesRepository.getSites().subscribe((sites: any) => {
                const numSites = sites.length;
                // return $translate("Entities.Site.NumActiveSitesFormat", { numSites}, "messageformat");
                this.subCaption = `${numSites} sites`;
                // }).then((subCaption: any) => {
                //    this.subCaption = subCaption;
                this.isLoading = false;
            });
        }, 10000);
    }
}
